import { LocationAutoCompleteInput } from 'shared/widgets/LocationAutoCompleteInput2'
import { useEffect, useState } from 'react'
import { useLazyReadAutoCompleteLocationsQuery } from 'entities/autoCompleteLocations/api/autoCompleteLocationsApi'
import { useDebouncedCallback } from 'use-debounce'

interface LocationAutoCompleteInputContainerProps{
    location: any
    text: string
    ref: any,
    isLoading?: boolean
    onInput?: (event: any) => void
    onLocationChange?: (event: any) => void
}

export const LocationAutoCompleteInputContainer = (props: LocationAutoCompleteInputContainerProps) => {
    const {
        location,
        text,
        ref,
        isLoading = false,
        onInput,
        onLocationChange
    } = props
 
    const [isOptionsLoading, setIsOptionsLoading] = useState<any>(false)
    const [isOptionsOpen, setIsOptionsOpen] = useState<any>(false)
    
    const [options, setOptions] = useState<any>(null)
    const [lazyReadAutoCompleteLocationsQuery] = useLazyReadAutoCompleteLocationsQuery()

    const debouncedGetLocationsOptions = useDebouncedCallback(   
        async (event: any) => {
            if (event === ``){
                setOptions([])
                return
            }

            setIsOptionsLoading(true)
            const lazyReadAutoCompleteLocationsQueryResult  = await lazyReadAutoCompleteLocationsQuery({query: text})

            if (lazyReadAutoCompleteLocationsQueryResult?.isError === true){
                setOptions([])
                setIsOptionsLoading(false)
                return
            }

            setOptions(lazyReadAutoCompleteLocationsQueryResult.data.list)    
            setIsOptionsLoading(false)
        },
        300
    )

    const handleLocationAutoCompleteInputInput = (event: any) => {
        onInput?.(event)
    }

    const handleLocationAutoCompleteInputFocus = (event: any) => {
         setIsOptionsOpen(true)
    }

    const handleLocationAutoCompleteInputLocationChange = (event: any) => {
        setIsOptionsOpen(false)
        onLocationChange?.(event)
    }

    useEffect(() => {
        debouncedGetLocationsOptions(text)
        setIsOptionsOpen(true)
    }, [
        text
    ])

    return (
        <LocationAutoCompleteInput
            location={location}
            ref={ref} 
            text={text}
            options={options}
            isLoading={isLoading}
            isOptionsLoading={isOptionsLoading}
            isOptionsOpen={isOptionsOpen}
            onInput={handleLocationAutoCompleteInputInput}
            onFocus={handleLocationAutoCompleteInputFocus}
            onLocationChange={handleLocationAutoCompleteInputLocationChange}
        />
    )
}